/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './discharge-summary.reducer';

export const DischargeSummaryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dischargeSummaryEntity = useAppSelector(state => state.dischargeSummary.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dischargeSummaryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dischargeSummary.detail.title">DischargeSummary</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.id">Id</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.id}</dd>
          <dt>
            <span id="summaryoftreatment">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.summaryoftreatment">Summaryoftreatment</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.summaryoftreatment}</dd>
          <dt>
            <span id="admissiondiagnosis">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.admissiondiagnosis">Admissiondiagnosis</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.admissiondiagnosis}</dd>
          <dt>
            <span id="finaldiagnosis">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.finaldiagnosis">Finaldiagnosis</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.finaldiagnosis}</dd>
          <dt>
            <span id="previousmedicines">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.previousmedicines">Previousmedicines</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.previousmedicines}</dd>
          <dt>
            <span id="treatementmedicines">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.treatementmedicines">Treatementmedicines</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.treatementmedicines}</dd>
          <dt>
            <span id="emergencyPlan">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.emergencyPlan">Emergency Plan</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.emergencyPlan}</dd>
          <dt>
            <span id="nextVisit">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.nextVisit">Next Visit</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.nextVisit}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.active">Active</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.cursor}</dd>
          <dt>
            <span id="dischargeType">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.dischargeType">Discharge Type</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.dischargeType}</dd>
          <dt>
            <span id="dischargeStatus">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.dischargeStatus">Discharge Status</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.dischargeStatus}</dd>
          <dt>
            <span id="sourceOfHistory">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.sourceOfHistory">Source Of History</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.sourceOfHistory}</dd>
          <dt>
            <span id="chiefComplaints">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.chiefComplaints">Chief Complaints</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.chiefComplaints}</dd>
          <dt>
            <span id="historyOfPresentIllness">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.historyOfPresentIllness">History Of Present Illness</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.historyOfPresentIllness}</dd>
          <dt>
            <span id="medicalHistory">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.medicalHistory">Medical History</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.medicalHistory}</dd>
          <dt>
            <span id="familyHistory">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.familyHistory">Family History</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.familyHistory}</dd>
          <dt>
            <span id="historyOfAllergies">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.historyOfAllergies">History Of Allergies</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.historyOfAllergies}</dd>
          <dt>
            <span id="historyOfImmunization">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.historyOfImmunization">History Of Immunization</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.historyOfImmunization}</dd>
          <dt>
            <span id="systemicExamination">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.systemicExamination">Systemic Examination</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.systemicExamination}</dd>
          <dt>
            <span id="discussion">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.discussion">Discussion</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.discussion}</dd>
          <dt>
            <span id="dietInstructions">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.dietInstructions">Diet Instructions</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.dietInstructions}</dd>
          <dt>
            <span id="followupInstructions">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.followupInstructions">Followup Instructions</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.followupInstructions}</dd>
          <dt>
            <span id="physicalActivityInstructions">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.physicalActivityInstructions">
                Physical Activity Instructions
              </Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.physicalActivityInstructions}</dd>
          <dt>
            <span id="normalcyAfter">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.normalcyAfter">Normalcy After</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.normalcyAfter}</dd>
          <dt>
            <span id="surgicalWoundClear">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.surgicalWoundClear">Surgical Wound Clear</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.surgicalWoundClear}</dd>
          <dt>
            <span id="painScore">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.painScore">Pain Score</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.painScore}</dd>
          <dt>
            <span id="vitalsStable">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.vitalsStable">Vitals Stable</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.vitalsStable ? 'true' : 'false'}</dd>
          <dt>
            <span id="ambulatory">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.ambulatory">Ambulatory</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.ambulatory ? 'true' : 'false'}</dd>
          <dt>
            <span id="intiitiatedById">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.intiitiatedById">Intiitiated By Id</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.intiitiatedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.modifiedById}</dd>
          <dt>
            <span id="intiitiatedByType">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.intiitiatedByType">Intiitiated By Type</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.intiitiatedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.dischargeSummary.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{dischargeSummaryEntity.modifiedByType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dischargeSummary.admission">Admission</Translate>
          </dt>
          <dd>{dischargeSummaryEntity.admission ? dischargeSummaryEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dischargeSummary.patient">Patient</Translate>
          </dt>
          <dd>{dischargeSummaryEntity.patient ? dischargeSummaryEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dischargeSummary.prescription">Prescription</Translate>
          </dt>
          <dd>{dischargeSummaryEntity.prescription ? dischargeSummaryEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dischargeSummary.approvedBy">Approved By</Translate>
          </dt>
          <dd>{dischargeSummaryEntity.approvedBy ? dischargeSummaryEntity.approvedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/discharge-summary" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/discharge-summary/${dischargeSummaryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DischargeSummaryDetail;
